module.exports = __webpack_public_path__ + "static/img/23.7464f2d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/23.png
// module id = gHF8
// module chunks = 1